import { createSlice } from '@reduxjs/toolkit';
import { ProductsImportStateType } from 'src/types/productsImport';

const initialState: ProductsImportStateType = {
    files: [],
    loading: false,
    importedData: { created: [], updated: [] },
};
export const productsImportSlice = createSlice({
    name: 'productsImport',
    initialState,
    reducers: {
        addFile: (state, action) => {
            state.files = [...state.files, { file: action.payload, loading: true }];
        },
        deleteFile: (state, action) => {
            state.files = state.files.filter((file) => file.file.name !== action.payload.name);
        },
        validateFileImportFetch: (state, action) => {},
        validateFileImportFetchSuccess: (state, action) => {
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    file.loading = false;
                    file.validation = action.payload.validation;
                }
                return file;
            });
        },
        validateFileImportFetchFailure: (state, action) => {
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    file.loading = false;
                    file.error = action.payload.errorMessage;
                }
                return file;
            });
        },
        importFileImportFetch: (state) => {
            state.loading = true;
        },
        importFileImportFetchSuccess: (state, action) => {
            state.loading = false;
            state.files = state.files = state.files.map((file) => {
                file.imported = true;
                return file;
            });
            state.importedData = action.payload.imported;
        },
        importFileImportFetchFailure: (state, action) => {
            state.loading = false;
        },
        clearProductsImport: () => initialState,
    },
});

export const {
    addFile,
    deleteFile,
    validateFileImportFetch,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importFileImportFetch,
    importFileImportFetchSuccess,
    importFileImportFetchFailure,
    clearProductsImport,
} = productsImportSlice.actions;

export default productsImportSlice.reducer;
